import React from 'react';
import { motion } from 'framer-motion';

export type ProgressSegment = {
  label: string;
  value: number;
  color: string;
};

interface AnimatedProgressBarProps {
  segments: ProgressSegment[];
  total: number;
  height?: string; // e.g. '8px'
  duration?: number; // animation duration in seconds
  rounded?: boolean;
}

export const AnimatedProgressBar: React.FC<AnimatedProgressBarProps> = ({
  segments,
  total,
  height = '8px',
  duration = 0.5,
  rounded = true,
}) => {
  return (
    <div
      className={`flex w-full overflow-hidden ${
        rounded ? 'rounded-full' : ''
      } bg-gray-100`}
      style={{ height }}
    >
      {segments.map((segment) => (
        <motion.div
          key={segment.label}
          className="h-full"
          style={{ background: segment.color }}
          animate={{ width: `${(segment.value / total) * 100}%` }}
          transition={{ duration, ease: 'easeInOut' }}
        />
      ))}
    </div>
  );
};

export default AnimatedProgressBar;
